import React, { useContext, useState } from "react"
import { MAX_PRODUCT_PRICE } from "../../config"
import { Context } from "../../store/store"
import ElemInput from "../elements/Input"
import ElemCheckboxProducts from "../elements/CheckboxProducts"
import { getText } from "../strapi"

interface ProductsProps {
	formElementChanged: Function
	validation: Record<string, any>
}

const Product: React.FC<ProductsProps> = ({ formElementChanged, validation }) => {
	const { globalState } = useContext(Context)
	const [selectedProducts, setSelectedProducts] = useState<string[]>([])

	const handleProductToggle = (value: string) => {
		let updatedSelection = [...selectedProducts]
		if (updatedSelection.includes(value)) {
			updatedSelection = updatedSelection.filter(v => v !== value)
		} else {
			if (updatedSelection.length >= 2) {
				updatedSelection.shift() // Entfernt das zuerst ausgewählte Produkt
			}
			updatedSelection.push(value)
		}

		setSelectedProducts(updatedSelection)
		formElementChanged({ target: { value: updatedSelection } }, "product")
	}

	const isSelected = (value: string) => selectedProducts.includes(value)

	return (
		<section className="mx-auto max-w-[850px]">
			<h3 className="mt-16 mb-6">{getText(globalState.strapi.homepage.selectProduct, "selectProduct")}</h3>
			<div className="align-items-top grid grid-cols-3  gap-4 js-formerror">
				{[
					{ id: "a", label: "Kirsch", image: "/images/can-cherry.png" },
					{ id: "b", label: "Zitrone Limette", image: "/images/can-lime.png" },
					{ id: "c", label: "Mango Passionsfrucht", image: "/images/can-passion.png" },
				].map((product, index) => (
					<div key={product.id} className="text-center">
						<ElemCheckboxProducts
							label={product.label}
							image={product.image}
							props={{
								type: "checkbox",
								name: "product1",
								required: true,
								checked: isSelected(product.id),
								onChange: () => handleProductToggle(product.id),
							}}
							className="mt-6"
						/>
					</div>
				))}
			</div>

			<div className="mb-12 lg:mb-2">
				{(validation["invalid_product1"] || validation["invalid_product2"]) && (
					<p className="mx-auto mb-12 mt-6 max-w-[80%] rounded-[5px] bg-white py-2 text-center text-errorred lg:max-w-[50%]">Bitte ein Produkt auswählen</p>
				)}
			</div>

			<div className=" mx-auto   grid max-w-[704px]   items-start gap-1 pt-10 pb-1  grid-cols-2 lg:gap-5">
				<ElemInput
					label={"Kaufbetrag in € exkl. Pfand**"}
					props={{
						type: "number",
						step: "0.01",
						min: "0.1",
						max: MAX_PRODUCT_PRICE,
						name: "purchaseAmount",
						value: globalState.purchaseAmount,
						required: "required",
						onChange: e => formElementChanged(e, "purchaseAmount"),
					}}
					hasError={!!validation["invalid_purchaseAmount"]}
					suffix="EUR"
					errMsg={validation["invalid_purchaseAmount_errMsg"] || "Bitte Kaufbetrag eingeben. (max. 3,98 EUR)"}
				/>

				<ElemInput
					label={"Kaufdatum**"}
					props={{
						type: "date",
						name: "purchaseDate",
						value: globalState.purchaseDate,
						required: "required",
						min: "2025-06-16",
						max: "2025-09-21",
						minLength: 1,
						onChange: e => formElementChanged(e, "purchaseDate"),
					}}
					className="kaufdatumBefore relative"
					hasError={!!validation["invalid_purchaseDate"]}
					errMsg={validation["invalid_purchaseDate_errMsg"] || "Bitte Kaufdatum eingeben."}
				/>
			</div>
		</section>
	)
}

export default Product
